export const GET_ADDPERMIT_TEXT = "GET_ADDPERMIT_TEXT";
export const SET_ADDPERMIT_TEXT = "SET_ADDPERMIT_TEXT";
export const GET_ADDPERMIT_SELECT_DATE = "GET_ADDPERMIT_SELECT_DATE";
export const SET_ADDPERMIT_SELECT_DATE = "SET_ADDPERMIT_SELECT_DATE";
export const GET_ADDPERMIT_WITHOUTSESSION_TEXT =
  "GET_ADDPERMIT_WITHOUTSESSION_TEXT";
export const SET_ADDPERMIT_WITHOUTSESSION_TEXT =
  "SET_ADDPERMIT_WITHOUTSESSION_TEXT";

export const getAddPermitText = (payload) => {
  return {
    type: GET_ADDPERMIT_TEXT,
    payload,
  };
};
export const setAddPermitText = (payload) => {
  return {
    type: SET_ADDPERMIT_TEXT,
    payload,
  };
};
export const getAddPermitSelectdate = (payload) => {
  return {
    type: GET_ADDPERMIT_SELECT_DATE,
    payload,
  };
};
export const setAddPermitSelectdate= (payload) => {
  return {
    type: SET_ADDPERMIT_SELECT_DATE,
    payload,
  };
};

export const getAddPermitWithoutSession = (payload) => {
  return {
    type: GET_ADDPERMIT_WITHOUTSESSION_TEXT,
    payload,
  };
};

export const setAddPermitWithoutSession = (payload) => {
  return {
    type: SET_ADDPERMIT_WITHOUTSESSION_TEXT,
    payload,
  };
};
